import { Component } from '@angular/core';

@Component({
  selector: 'app-success-icon',
  standalone: true,
  imports: [],
  template: `
    <svg
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      width="1024"
      height="1024"
      viewBox="0 0 1024 1024"
      class="h-5 w-5 text-success">
      <g id="icomoon-ignore"></g>
      <path
        class="fill-current"
        fill-opacity="0.1"
        fill="currentColor"
        d="M507.733 72.531c-91.981 0-181.897 27.276-258.377 78.378s-136.089 123.736-171.288 208.716c-35.2 84.98-44.41 178.487-26.465 268.702s62.238 173.082 127.279 238.123c65.041 65.041 147.907 109.333 238.122 127.279s183.722 8.734 268.701-26.466c84.983-35.2 157.615-94.805 208.717-171.285s78.379-166.396 78.379-258.381c-0.115-123.306-49.148-241.531-136.341-328.723s-205.419-136.227-328.725-136.341z"></path>
      <path
        fill="currentColor"
        d="M512 125.122c80.738 0 159.659 23.941 226.79 68.796 67.127 44.855 119.45 108.609 150.349 183.2 30.895 74.59 38.98 156.668 23.228 235.853s-54.63 151.923-111.718 209.011c-57.088 57.088-129.826 95.966-209.011 111.718s-161.263 7.667-235.853-23.228c-74.591-30.899-138.345-83.221-183.199-150.349-44.855-67.132-68.796-146.052-68.796-226.79 0-108.265 43.008-212.094 119.562-288.649s180.384-119.562 288.649-119.562zM471.398 597.947l-134.034-134.468c-7.83-7.339-18.088-11.533-28.815-11.789-8.058 0.081-15.913 2.53-22.588 7.044s-11.872 10.893-14.945 18.342c-3.073 7.45-3.885 15.642-2.334 23.548s5.394 15.181 11.052 20.919l162.847 163.285c7.996 7.117 18.33 11.051 29.035 11.051s21.039-3.934 29.035-11.051l244.489-244.927c5.658-5.737 9.502-13.013 11.051-20.921 1.553-7.907 0.738-16.096-2.334-23.546s-8.269-13.829-14.946-18.344c-6.673-4.515-14.528-6.964-22.588-7.044-10.726 0.255-20.983 4.451-28.813 11.788l-215.676 218.295zM512 64c-92.825 0-183.566 27.526-260.748 79.097s-137.337 124.871-172.86 210.63c-35.523 85.76-44.817 180.127-26.708 271.169s62.809 174.669 128.446 240.307c65.638 65.634 149.265 110.336 240.306 128.444 91.042 18.112 185.408 8.815 271.168-26.705 85.76-35.524 159.061-95.68 210.633-172.86 51.571-77.184 79.095-167.923 79.095-260.749-0.115-124.439-49.6-243.749-137.591-331.741s-207.3-137.477-331.742-137.592z"></path>
    </svg>
  `,
})
export class SuccessIconComponent {}
